export default function getSelectedDates(_ref) {
  let {
    range,
    date,
    startDate,
    endDate
  } = _ref;
  let dates;
  if (range) {
    dates = [startDate !== null && startDate !== void 0 ? startDate : null, endDate !== null && endDate !== void 0 ? endDate : null];
  } else {
    dates = date ? [date] : null;
  }
  return dates;
}
//# sourceMappingURL=getSelectedDates.js.map